export var LifeCycleTypes;
(function (LifeCycleTypes) {
    LifeCycleTypes["OnFormSubmit"] = "OnFormSubmit";
    LifeCycleTypes["OnFormReset"] = "OnFormReset";
    LifeCycleTypes["OnFormSubmitSuccess"] = "OnFormSubmitSuccess";
    LifeCycleTypes["OnFormSubmitFailed"] = "OnFormSubmitFailed";
    LifeCycleTypes["OnFormValuesChange"] = "OnFormValuesChange";
    LifeCycleTypes["OnFormInitialValueChange"] = "OnFormInitialValueChange";
    LifeCycleTypes["OnWidgetValueChange"] = "OnWidgetValueChange";
    LifeCycleTypes["OnWidgetInitialValueChange"] = "OnWidgetInitialValueChange";
    LifeCycleTypes["OnWidgetReset"] = "OnWidgetReset";
})(LifeCycleTypes || (LifeCycleTypes = {}));
